<template>
  <v-container fluid class="fill-height pa-1" v-resize="onResize">
    <!-- Tabulka Lhc -->
    <v-data-table :headers="Tab_SeznamLhc_headers" :items="VybSeznamLhc" :items-per-page="13"
      :search="Tab_SeznamLhc_search" :loading="IsLoading" class="rounded-lg" fixed-header single-expand show-expand
      multi-sort item-key="LHC_KOD" :height="Tab_Seznam_Height">
      <template v-slot:top>
        <v-card outlined class="pa-2" rounded="lg">
          <v-row ref="DivTabHeader">
            <v-col cols="auto">
              <v-card width="295">
                <v-text-field label="Zadejte část kódu nebo názvu Lhc" v-model="Tab_SeznamLhc_search" hide-details="true"
                  class="mb-4 mx-3"></v-text-field>

                <v-btn-toggle mandatory v-model="Tab_SeznamLhc_searchLhpo" class="ml-5" v-if="AppCategory == 'LHPO'">
                  <v-btn color="secondary" value="lhpo">Lhp / Lho</v-btn>
                  <v-btn color="secondary" value="plán" class="px-5">
                    Lhp
                  </v-btn>
                  <v-btn color="secondary" value="osnova" class="px-5">
                    Lho
                  </v-btn>
                </v-btn-toggle>
              </v-card>
            </v-col>

            <v-col cols="auto">
              <v-card width="135">
                <v-select label="Platnost od:" color="primary" clearable filled dense background-color="secondary"
                  v-model="Tab_SeznamLhc_searchLhpOd" :items="Tab_SeznamLhc_LhpOd" hide-details="true"
                  class="mb-2"></v-select>
                <v-select label="Platnost do:" color="primary" clearable filled dense background-color="secondary"
                  v-model="Tab_SeznamLhc_searchLhpDo" :items="Tab_SeznamLhc_LhpDo" hide-details="true"></v-select>
              </v-card>
            </v-col>

            <v-col cols="auto">
              <v-card width="200">
                <v-select label="Kraj" color="primary" clearable filled dense background-color="secondary"
                  v-model="Tab_SeznamLhc_searchKraj" :items="Tab_SeznamLhc_Kraj" hide-details="true"
                  class="mb-2"></v-select>
                <v-autocomplete label="Orp" color="primary" clearable filled dense background-color="secondary"
                  v-model="Tab_SeznamLhc_searchOrp" :items="Tab_SeznamLhc_Orp" hide-details="true"></v-autocomplete>
              </v-card>
            </v-col>

            <v-col cols="auto">
              <v-card width="240">
                <v-autocomplete label="Název katastrálního území" color="primary" clearable filled dense
                  background-color="secondary" v-model="Tab_SeznamLhc_searchKuNaz" :items="Tab_SeznamLhc_KuNaz"
                  hide-details="true" class="mb-2">
                </v-autocomplete>
                <v-autocomplete label="Kód katastrálního území" color="primary" clearable filled dense
                  background-color="secondary" v-model="Tab_SeznamLhc_searchKuKod" :items="Tab_SeznamLhc_KuKod"
                  hide-details="true">
                </v-autocomplete>
              </v-card>
            </v-col>

            <v-col cols="auto" v-if="SeznamDs.length > 1">
              <v-card width="335">
                <v-select v-model="VybDS" :items="SeznamDs" item-text="Value" item-value="Key" label="Databáze"
                  color="primary" filled dense background-color="info" hide-details="true" class="mb-2"></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-slot:item.LHC_KOD="{ item }">
        <v-chip color="accent">
          {{ item.LHC_KOD }}
        </v-chip>
      </template>
      <template v-slot:item.LHP_OD="{ item }">
        {{ item.LHP_OD }} - {{ item.LHP_DO }}
      </template>
      <template v-slot:item.TYP_LHC="{ item }">
        <v-chip color="primary2" v-show="item.TYP_LHC == 'plán'">
          {{ item.TYP_LHC }}
        </v-chip>
        <v-chip light color="amber" v-show="item.TYP_LHC == 'osnova'">
          {{ item.TYP_LHC }}
        </v-chip>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row dense>
            <v-col cols="auto" class="pa-1 my-1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="secondary" class="py-8" v-bind="attrs" v-on="on" @click="VybratStav(item)">
                    <v-icon>mdi-puzzle</v-icon>
                  </v-btn>
                </template>
                <span>Karta Lhc / majetku</span>
              </v-tooltip>
            </v-col>

            <v-col>
              <v-card color="info" min-width="300" class="pa-1 my-1">
                <v-card-title>{{ item.ORG_MAJ.NAZEV }}</v-card-title>
                <v-card-subtitle class="accent--text">Vlastník</v-card-subtitle>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success">mdi-postage-stamp </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_MAJ.ULICE }} {{ item.ORG_MAJ.ULICE1 }},
                    {{ item.ORG_MAJ.POSTA }} {{ item.ORG_MAJ.PSC }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-phone-classic </v-icon></v-col>
                  <v-col cols="11">{{ item.ORG_MAJ.TELEFON }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-at </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_MAJ.EMAIL }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-human-greeting </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_MAJ.ZASTUPCE }}</v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col>
              <v-card color="info" min-width="300" class="pa-1 my-1">
                <v-card-title>{{ item.ORG_ZPRAC.NAZEV }}</v-card-title>
                <v-card-subtitle class="accent--text">Zpracovatel</v-card-subtitle>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-postage-stamp </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_ZPRAC.ULICE }} {{ item.ORG_ZPRAC.ULICE1 }},
                    {{ item.ORG_ZPRAC.POSTA }} {{ item.ORG_ZPRAC.PSC }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-phone-classic </v-icon></v-col>
                  <v-col cols="11">{{ item.ORG_ZPRAC.TELEFON }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-at </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_ZPRAC.EMAIL }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-human-greeting </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_ZPRAC.ZASTUPCE }}</v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col>
              <v-card color="info" min-width="300" class="pa-1 my-1">
                <v-card-title>{{ item.ORG_SSL.NAZEV }}</v-card-title>
                <v-card-subtitle class="accent--text">Schválil</v-card-subtitle>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-postage-stamp </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_SSL.ULICE }} {{ item.ORG_SSL.ULICE1 }},
                    {{ item.ORG_SSL.POSTA }} {{ item.ORG_SSL.PSC }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-phone-classic </v-icon></v-col>
                  <v-col cols="11">{{ item.ORG_SSL.TELEFON }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-at </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_SSL.EMAIL }}</v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="1">
                    <v-icon color="success"> mdi-human-greeting </v-icon>
                  </v-col>
                  <v-col cols="11">{{ item.ORG_SSL.ZASTUPCE }}</v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>

    <!-- Výběr -->
    <div class="d-none"></div>

    <!-- Stav Lhc -->
    <v-dialog v-model="Dialog_stav_view" width="250">
      <v-card>
        <v-card-title class="primary2"> Stav Lhc </v-card-title>
        <v-card-text class="mt-5">
          <v-btn class="ma-1" color="secondary" block @click="
            Dialog_stav_view = false;
          Dialog_stav_close('SchvalenyStav');
                                                                                                ">
            Schválený stav
          </v-btn>
          <v-btn class="ma-1" color="secondary" block @click="
            Dialog_stav_view = false;
          Dialog_stav_close('SouvisleZobrazeni');
                                                                                                ">
            Souvislé zobrazení
          </v-btn>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" text @click="Dialog_stav_view = false">
            Zavřít
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Výběr majetku -->
    <v-dialog v-model="Dialog_maj_view" scrollable max-width="600">
      <v-card>
        <v-card-title class="primary2">
          <div>Výběr majetku</div>
          <v-spacer />
          <v-avatar color="info">
            <v-icon dark> mdi-account-search </v-icon>
          </v-avatar>
        </v-card-title>

        <v-data-table :headers="Tab_MajLhc_headers" :items="VybLhcMaj_maj" :items-per-page="10"
          :search="Tab_MajLhc_search" class="" hide-default-header item-key="MAJ_KOD" height="450">
          <template v-slot:top>
            <v-alert type="info" dense>
              <div>Vybrali jste Lhc, které obsahuje více majetků.</div>
              <div>Můžete vybrat konkrétního majitele nebo celé Lhc.</div>
            </v-alert>

            <v-text-field v-model="Tab_MajLhc_search" label="Zadejte libovolnou část kódu nebo názvu majetku"
              class="mx-4"></v-text-field>
          </template>
          <template v-slot:item.MAJ_KOD="{ item }">
            <v-btn rounded color="secondary" @click="
              Dialog_maj_view = false;
            Dialog_maj_close(item.MAJ_KOD, item.MAJ_POPIS);
                                                                                                                ">
              {{ item.MAJ_KOD }}
            </v-btn>
          </template>
        </v-data-table>

        <v-card-actions class="">
          <v-spacer />
          <v-btn color="secondary" @click="
            Dialog_maj_view = false;
          Dialog_maj_close(null, null);
                                                                                                ">
            Celé Lhc
          </v-btn>
          <v-spacer />
          <v-btn color="primary" text @click="Dialog_maj_view = false">
            Zavřít
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import ServiceLhpo from "../services/ServiceLhpo";
import LhcVyberFunc from "./LhcVyber/function";

export default {
  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Tabulka Lhc - hlavička
      Tab_SeznamLhc_headers: [
        { text: "Kód", value: "LHC_KOD", width: "110" },
        { text: "Platnost", value: "LHP_OD", width: "110", filterable: false },
        {
          text: "Typ",
          value: "TYP_LHC",
          width: "100",
          filter: (value) => {
            if (this.Tab_SeznamLhc_searchLhpo == "lhpo") return true;
            return value == this.Tab_SeznamLhc_searchLhpo;
          },
        },
        { text: "Název", value: "LHC_NAZ" },
        {
          text: "searchLhpOd",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchLhpOd) return true;
            if (!item) return true;
            return item.LHP_OD == this.Tab_SeznamLhc_searchLhpOd;
          },
        },
        {
          text: "searchLhpDo",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchLhpDo) return true;
            if (!item) return true;
            return item.LHP_DO == this.Tab_SeznamLhc_searchLhpDo;
          },
        },
        {
          text: "searchKraj",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchKraj) return true;
            if (!item) return true;
            return LhcVyberFunc.SearchKraj(
              item.KRAJs,
              this.Tab_SeznamLhc_searchKraj
            );
          },
        },
        {
          text: "searchOrp",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchOrp) return true;
            if (!item) return true;
            return LhcVyberFunc.SearchOrp(
              item.ORPs,
              this.Tab_SeznamLhc_searchOrp
            );
          },
        },
        {
          text: "searchKuNaz",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchKuNaz) return true;
            if (!item) return true;
            return LhcVyberFunc.SearchKuNaz(
              item.KATUZEs,
              this.Tab_SeznamLhc_searchKuNaz
            );
          },
        },
        {
          text: "searchKuKod",
          class: "d-none",
          cellClass: "d-none",
          filter: (value, search, item) => {
            if (!this.Tab_SeznamLhc_searchKuKod) return true;
            if (!item) return true;
            return LhcVyberFunc.SearchKuKod(
              item.KATUZEs,
              this.Tab_SeznamLhc_searchKuKod
            );
          },
        },
      ],

      // Tabulka Lhc - hledání podle kodu a nazvu
      Tab_SeznamLhc_search: "",
      // Tabulka Lhc - hledání podle lhpo
      Tab_SeznamLhc_searchLhpo: "lhpo",
      // Tabulka Lhc - hledání podle LHP_OD
      Tab_SeznamLhc_LhpOd: [],
      // Tabulka Lhc - hledání podle LHP_OD
      Tab_SeznamLhc_searchLhpOd: "",
      // Tabulka Lhc - hledání podle LHP_DO
      Tab_SeznamLhc_LhpDo: [],
      // Tabulka Lhc - hledání podle LHP_DO
      Tab_SeznamLhc_searchLhpDo: "",
      // Tabulka Lhc - hledání podle Kraj
      Tab_SeznamLhc_Kraj: [],
      // Tabulka Lhc - hledání podle Kraj
      Tab_SeznamLhc_searchKraj: "",
      // Tabulka Lhc - hledání podle Orp
      Tab_SeznamLhc_Orp: [],
      // Tabulka Lhc - hledání podle Orp
      Tab_SeznamLhc_searchOrp: "",
      // Tabulka Lhc - hledání podle KuNaz
      Tab_SeznamLhc_KuNaz: [],
      // Tabulka Lhc - hledání podle KuNaz
      Tab_SeznamLhc_searchKuNaz: "",
      // Tabulka Lhc - hledání podle KuKod
      Tab_SeznamLhc_KuKod: [],
      // Tabulka Lhc - hledání podle KuKod
      Tab_SeznamLhc_searchKuKod: "",

      // Tabulka Maj - hlavička
      Tab_MajLhc_headers: [
        { text: "Kód", value: "MAJ_KOD", width: "70" },
        { text: "Platnost", value: "MAJ_POPIS", width: "" },
      ],
      // Tabulka Maj - hledání
      Tab_MajLhc_search: "",

      // Dialog - Lhc stav
      Dialog_stav_view: false,
      // Dialog - Lhc majetky
      Dialog_maj_view: false,

      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      // Nahrávám
      IsLoading: false,

      // Výška tabulky
      Tab_Seznam_Height: 300,

      // Vybraný DS
      aVybDS: null,
      // Vybraný seznam Lhc vybraného DS
      aVybSeznamLhc: [],

      // Seznam DS
      SeznamDs: [],

      // Vybrané Lhc
      VybLhc: null,
      // Vybrané Lhc s majetky
      // { Jid: null, majs: [] }
      VybLhcMaj: null,
    };
  },

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Vybraný DS
    VybDS: {
      get() {
        return this.aVybDS;
      },
      set(newValue) {
        if (this.aVybDS !== newValue) {
          this.aVybDS = newValue;

          this.IsLoading = true;

          // změna ds - promazat
          this.Tab_SeznamLhc_search = null;
          this.Tab_SeznamLhc_searchLhpo = "lhpo";
          this.Tab_SeznamLhc_LhpOd = [];
          this.Tab_SeznamLhc_searchLhpOd = null;
          this.Tab_SeznamLhc_LhpDo = [];
          this.Tab_SeznamLhc_searchLhpDo = null;
          this.Tab_SeznamLhc_Kraj = [];
          this.Tab_SeznamLhc_searchKraj = null;
          this.Tab_SeznamLhc_Orp = [];
          this.Tab_SeznamLhc_searchOrp = null;
          this.Tab_SeznamLhc_KuNaz = [];
          this.Tab_SeznamLhc_searchKuNaz = null;
          this.Tab_SeznamLhc_KuKod = [];
          this.Tab_SeznamLhc_searchKuKod = null;

          this.Tab_MajLhc_search = null;

          this.VybLhc = null;
          this.VybLhcMaj = null;

          // nový seznam
          this.NactiDsSeznamLhc(newValue);
        }
      },
    },

    // Vybraný seznam Lhc vybraného DS
    VybSeznamLhc: {
      get() {
        return this.aVybSeznamLhc;
      },
      set(newValue) {
        this.aVybSeznamLhc = newValue;

        //seznamy
        this.Tab_SeznamLhc_LhpOd = LhcVyberFunc.VytvorSeznamLHP_OD(newValue);
        this.Tab_SeznamLhc_LhpDo = LhcVyberFunc.VytvorSeznamLHP_DO(newValue);
        this.Tab_SeznamLhc_Kraj = LhcVyberFunc.VytvorSeznamKraj(newValue);
        this.Tab_SeznamLhc_Orp = LhcVyberFunc.VytvorSeznamOrp(newValue);
        this.Tab_SeznamLhc_KuNaz = LhcVyberFunc.VytvorSeznamKuNaz(newValue);
        this.Tab_SeznamLhc_KuKod = LhcVyberFunc.VytvorSeznamKuKod(newValue);

        this.IsLoading = false;
      },
    },

    // Vybrané Lhc s majetky - seznam majetků
    VybLhcMaj_maj: function () {
      if (this.VybLhcMaj == null) {
        return [];
      } else {
        return this.VybLhcMaj.majs;
      }
    },
  },

  methods: {
    // při změně velikosti
    onResize: function () {
      // změna výšky tabulky - velikosto okna-hlavička-zápatí-hlavička tabulky-zápatí tabulky-margin
      if (!(this.$refs.DivTabHeader == null)) {
        this.Tab_Seznam_Height =
          window.innerHeight -
          48 -
          42 -
          this.$refs.DivTabHeader.clientHeight -
          59 -
          2;
      }
    },

    // První funkce při výběru Lhc - výběr stavu
    VybratStav: function (vLhc) {
      this.VybLhc = Object.assign({}, vLhc);

      switch (this.VybDS) {
        case "islh_lhc_data":
          if (this.AppCategory == "LHO") {
            // DS LHO

            this.VybLhc.LhcStav = "SouvisleZobrazeni";
            this.VybratMajetek();
          } else {
            // DS SSL

            if (this.VybLhc.LHC_KOD > 900000) {
              this.VybLhc.LhcStav = "SouvisleZobrazeni";
              this.VybratMajetek();
            } else {
              this.Dialog_stav_view = true;
            }
          }

          break;

        case "islh_lhc_1rok":
          this.VybLhc.LhcStav = "SchvalenyStav";
          this.VybratMajetek();

          break;
        case "islh_lhc_nsch":
          this.VybLhc.LhcStav = "SchvalenyStav";
          this.VybratMajetek();

          break;

        case "islh_lhc_arch":
          this.VybLhc.LhcStav = "SchvalenyStav";
          this.VybratMajetek();

          break;

        default:
        // code block
      }
    },

    // Konec dialogu na výběr stavu
    Dialog_stav_close: function (stav) {
      if (stav == "SouvisleZobrazeni") {
        // Souvislé zobrazené - U_LHC_STAV lze přebrat

        this.VybLhc.LhcStav = "SouvisleZobrazeni";
        this.VybratMajetek();
      } else if (stav == "SchvalenyStav") {
        // U_LHC_STAV zjistit přes službu

        this.VybLhc.LhcStav = "SchvalenyStav";
        this.NactiLhcInfoStav(this.VybDS + "-" + this.VybLhc.U_JID, 2);
      }
    },

    // Seznam majetků vybraného Lhc
    VybratMajetek: function () {
      if (this.VybLhcMaj == null) {
        this.NactiLhcSeznamMaj(this.VybDS + "-" + this.VybLhc.U_JID);
      } else {
        if (this.VybDS + "-" + this.VybLhc.U_JID != this.VybLhcMaj.Jid) {
          this.NactiLhcSeznamMaj(this.VybDS + "-" + this.VybLhc.U_JID);
        } else {
          this.NastavMajetky();
        }
      }
    },

    NastavMajetky: function () {
      if (this.VybLhcMaj == null) {
        // prázdný seznam - chyba
        this.Alert_text =
          "Při záskávání informací došlo k chybě, zkuste akci zopakovat";
        this.Alert_view = true;
      } else {
        if (this.VybLhcMaj.majs.length == 0) {
          // Uživatel nemá oprávnění
          this.Alert_text =
            "Omlouváme se, ale na prohlížení detailních informací k požadovanému LHC nemáte oprávnění.";
          this.Alert_view = true;
        } else if (this.VybLhcMaj.majs.length == 1) {
          // jeden majetek
          this.VybratLhcMaj();
        } else {
          // Více majetků
          this.Dialog_maj_view = true;
        }
      }
    },

    // Konec dialogu na výběr majetku
    Dialog_maj_close: function (MajKod, MajPop) {
      this.VybLhc.MAJ.MAJ_KOD = MajKod;
      this.VybLhc.MAJ.MAJ_POPIS = MajPop;
      this.VybratLhcMaj();
    },

    // Konečný výběr Lhc s majetkem
    VybratLhcMaj: function () {
      var vLhc = {
        JidDs: this.VybDS,
        Jid: this.VybDS + "-" + this.VybLhc.U_JID,
        LhcKod: this.VybLhc.LHC_KOD,
        LhcNaz: this.VybLhc.LHC_NAZ,
        MajKod: this.VybLhc.MAJ.MAJ_KOD,
        MajNaz: this.VybLhc.MAJ.MAJ_POPIS,
        LhpOd: this.VybLhc.LHP_OD,
        LhpDo: this.VybLhc.LHP_DO,
        LhcStav: this.VybLhc.LhcStav,
        SchvStav: this.VybLhc.LhcStav == "SchvalenyStav" ? true : false,
        ULhcStav: this.VybLhc.U_LHC_STAV,
        ULhcStavS: this.VybLhc.U_JID.slice(0, 3),
        Rocnik: this.VybLhc.ROCNIK,
        Kraje: this.VybLhc.KRAJs,
        Orp: this.VybLhc.ORPs,
        Ku: this.VybLhc.KATUZEs,
        Plo: this.VybLhc.PLOs,
        OrgMaj: this.VybLhc.ORG_MAJ,
        OrgSsl: this.VybLhc.ORG_SSL,
        OrgZprac: this.VybLhc.ORG_ZPRAC,
        Pobocka: this.VybLhc.POBOCKA,
        Coordinate: this.VybLhc.Coordinate,
      };

      this.$store.commit("SET_sVybLhc", vLhc);
      this.VybComp = "LhcInfo";
    },

    // WS - Seznam Ds
    NactiSeznamDs: function () {
      ServiceLhpo.SeznamDs()
        .then((response) => {
          if (response.data.Dokonceno) {
            this.SeznamDs = response.data.SeznamDs;
            this.VybDS = this.SeznamDs[0].Key;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.VybSeznamLhc = null;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Seznam Lhc
    NactiDsSeznamLhc: function (Jid) {
      ServiceLhpo.DsSeznamLhc(Jid)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.VybSeznamLhc = response.data.SeznamLhc;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.VybSeznamLhc = null;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - ULhcStav podle LhcStav vybraného Lhc
    // LhcStav 1 - SouvisleZobrazeni
    // LhcStav 2 - SchvalenyStav
    NactiLhcInfoStav: function (Jid, LhcStav) {
      ServiceLhpo.LhcInfoStav(Jid, LhcStav)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.VybLhc.U_LHC_STAV = parseInt(
              response.data.InfoStav.substr(0, 3)
            );
            this.VybLhc.U_JID = response.data.InfoStav;
            this.VybratMajetek();
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //nic
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Seznam majetků vybraného Lhc
    NactiLhcSeznamMaj: function (Jid) {
      ServiceLhpo.LhcSeznamMaj(Jid)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.VybLhcMaj = {
              Jid: response.data.Zadani.Jid,
              majs: response.data.SeznamMaj,
            };
            this.NastavMajetky();
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.VybLhcMaj = null;
          this.NastavMajetky();
        })
        .then(function () {
          // always executed
        });
    },
  },

  watch: {},

  mounted() {
    // Vytvoření

    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);

    // první načtení seznamu
    this.IsLoading = true;
    // nový seznam Ds
    this.NactiSeznamDs();

    this.onResize();
  },
};
</script>